export default __webpack_public_path__ + "static/media/PersonFolder.d995f707.svg";